// extracted by mini-css-extract-plugin
module.exports = {"headerContainer":"Header_headerContainer__30Vcj","addWidgetButton":"Header_addWidgetButton__3J_cy","dashboardTabs":"Header_dashboardTabs__2pmB9","active":"Header_active__3OgYA"};